// extracted by mini-css-extract-plugin
module.exports = {"displaygrid":"partners-module--displaygrid--yQXnk","partnerlogo":"partners-module--partnerlogo--AK-6_"};